import { render, staticRenderFns } from "./bao-cao-bao-hang.vue?vue&type=template&id=3814c1cc&"
import script from "./bao-cao-bao-hang.vue?vue&type=script&lang=js&"
export * from "./bao-cao-bao-hang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports